export enum Device {
    mobile = 'mobile',
    tabletPortrait = 'tabletPortrait',
    tabletLandscape = 'tabletLandscape',
    desktop = 'desktop',
}

export interface UseDeviceWidth {
    device?: Device;
    isMobile: boolean;
    isTabletPortrait: boolean;
    isTabletLandscape: boolean;
    isDesktop: boolean;
}

export const deviceMinWidths: Record<Device, number> = {
    mobile: 0,
    tabletPortrait: 768,
    tabletLandscape: 1024,
    desktop: 1448,
};
